import React, { useEffect, useState } from 'react';

import { Modal } from 'antd';
import SPMapFence from 'components/carRental/storeManagement/SPMapFence';

type PropsType = {
  type?: string;
  title?: string;
  visible: boolean;
  onOk?: any;
  onClose?: any;
  polygons?: any;
  extraPolygons?: any;
  onPolygonChange?: any;
  position?: any;
}

const SPMapFenceModal:React.FC<PropsType> = (props) => {
  const { visible, onOk, onClose, title= '服务范围预览', polygons, type, position, extraPolygons } = props || {};

  const [polygonsDraw, setPolygonsDraw] = useState<any>([]);

  const handleOk = () => {
    onOk && onOk(polygonsDraw);
    onClose();
    setPolygonsDraw([]);
  };

  const handleCancel = () => {
    onClose();
  };

  const handlePolygonsDrawChange = (polygon: any) => {
    setPolygonsDraw(polygon);
  }

  useEffect(() => {
    if (visible && polygons && polygons[0]) {
      setPolygonsDraw(polygons[0]);
    }
  }, [visible, polygons]);

  const okBtnStyle = type === 'view' ? { display: 'none' } : {};
  const cancelText = type === 'view' ? '关闭' : '取消';

  return (
    <Modal title={title} open={visible} width="80%" onOk={handleOk} cancelText={cancelText} onCancel={handleCancel} destroyOnClose okButtonProps={{style: okBtnStyle}}>
      <SPMapFence polygons={polygons} extraPolygons={extraPolygons} position={position} plugins={['ShapeEdit']} onPolygonChange={handlePolygonsDrawChange} type={type} />
    </Modal>
  )
}

export default SPMapFenceModal;
